import { render } from "./LetterLayout.vue?vue&type=template&id=2c7fe7ac"
import script from "./LetterLayout.vue?vue&type=script&lang=js"
export * from "./LetterLayout.vue?vue&type=script&lang=js"

import "./LetterLayout.vue?vue&type=style&index=0&id=2c7fe7ac&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__